import {
  isPostPreviewSupported,
  SkedPreview,
} from '@dialogueconsulting/sked-preview'
import { cn } from '@dialogueconsulting/sked-ui/lib/utils'

import GlobalStyle from 'GlobalStyle'
import type { PreviewVariant } from 'utils/postPreviewVariant'

export interface SkedPreviewFrameProps {
  post: Record<string, any>
  previewVariant: PreviewVariant
  legacyClassName: string
  upliftWrapperClassName?: string
  testId?: string
}

const SkedPreviewFrame = ({
  post,
  previewVariant,
  legacyClassName,
  upliftWrapperClassName,
  testId,
}: SkedPreviewFrameProps) => {
  const isSupported = isPostPreviewSupported(post as any)
  const shouldUseNeutralFrame = !isSupported || previewVariant === 'uplift'
  const shouldRenderUplift = isSupported && previewVariant === 'uplift'

  if (shouldUseNeutralFrame) {
    return (
      <div
        data-testid={testId}
        data-external-review-sked-preview={
          shouldRenderUplift ? 'uplift' : 'unsupported'
        }
        className={cn(
          'mx-auto flex w-full justify-center',
          upliftWrapperClassName
        )}
      >
        <SkedPreview
          post={post as any}
          env={undefined}
          previewVariant={previewVariant}
          trackEvent={undefined}
          videoCoverPreview={post?.providedPost?.thumbnailUrl}
        />
      </div>
    )
  }

  return (
    <div data-testid={testId} data-external-review-sked-preview="legacy">
      <GlobalStyle />
      <SkedPreview
        post={post as any}
        className={legacyClassName}
        env={undefined}
        previewVariant={previewVariant}
        trackEvent={undefined}
        videoCoverPreview={post?.providedPost?.thumbnailUrl}
      />
    </div>
  )
}

export default SkedPreviewFrame
